export default __webpack_public_path__ + "static/media/nbs-circle-empty-cover.c5b098df.jpg";